<template>
	<component v-bind:is="iframeModal ? 'layout-blank' : 'layout-splash'">
		<ui-modal
			ref="deleteModal"
			:small="true"
			:confirm-label="__('Delete')"
			v-on:confirm="deleteContract()"
			v-on:dismiss="showDeleteModal = false"
			v-on:close="showDeleteModal = false"
			v-if="showDeleteModal"
			>{{ __("Do you want to delete the contract?") }}</ui-modal
		>

		<form class="h-full flex flex-col">
			<div class="bg-green-500 px-6 py-4 text-white">
				<div class="flex justify-between items-baseline pr-4 mr-6">
					<h1 class="text-4xl font-bold">
						<span v-if="creating">
							{{ __("Create new external contract") }}
						</span>
						<span v-else>
							{{ __("Update external contract") }}
						</span>
					</h1>
				</div>

				<ui-button
					type="blank"
					class="absolute right-5 top-5"
					v-if="iframeModal"
					v-on:click="closeIframeModal()"
				>
					<ui-icon class="h-9 w-9 text-white" name="x" stroke-width="2" />
				</ui-button>
			</div>

			<my-contracts-edit-step1
				:contract="contract"
				:user="user"
				:form="form"
				:creating="creating"
				v-if="step == 1"
			/>

			<my-contracts-edit-step2
				:contract="contract"
				:user="user"
				:form="form"
				:creating="creating"
				v-if="step == 2"
				:userLocations="userLocations"
			/>

			<div class="bg-gray-100 px-6 pt-4 pb-6">
				<div class="flex justify-between mt-4">
					<ui-button
						type="secondary"
						v-if="step > 1"
						v-on:click="step--"
						label="Back"
					/>
					<ui-button
						v-else-if="!creating && step == 1"
						v-on:click="showDeleteModal = true"
						label="Delete"
						type="primary-reverted"
						:class="'bg-white'"
					/>

					<ui-button
						class="ml-auto"
						v-if="step <= 1"
						v-on:click="
							() => {
								tryGotoStep(step + 1);
							}
						"
						label="Next"
					/>
					<ui-button
						class="ml-auto"
						v-else
						:disabled="submitButtonDisabled"
						v-on:click="submitForm()"
						label="Save"
					/>
				</div>
			</div>
		</form>
	</component>
</template>

<script>
import UiWizzard from "../components/Ui/Wizzard.vue";
import axios from "axios";
export default {
	mixins: [UiWizzard],
	props: {
		contract: {
			type: Object,
			required: true,
		},
		user: {
			type: Object,
			required: true,
		},
		userLocations: {
			type: Array,
			required: true
		},
		userUploads: {
			type: Array,
			required: true,
		},
		iframeModal: {
			type: Boolean,
			default: false,
		},
		creating: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		this.contract.file = null;
		return {
			form: Vue.observable(this.$inertia.form(this.contract)),
			step: 1,
			steps: [
				{ name: "Step 1", href: "#" },
				{ name: "Step 2", href: "#" },
			],
			priceTypeIsNone: false,
			submitButtonDisabled: false,
			showDeleteModal: false,
		};
	},
	computed: {
		hasErrors() {
			return Object.keys(this.form.errors).length > 0;
		},
	},
	methods: {
		async submitForm() {
			let endpoint = "",
				method = "post",
				that = this;
			if (!this.creating && this.contract.id) {
				endpoint =
					window.baseUrl +
					"/external-contract/" +
					this.contract.id +
					"/update?iframe_modal=true";
			} else {
				endpoint = window.baseUrl + "/external-contract/save?iframe_modal=true";
			}
			this.submitButtonDisabled = true;
			this.form.submit(method, endpoint, {
				preserveState: true,
				onSuccess(p) {
					console.log("SUCCESS SUBMISSION, got: ", p);
					window.parent.location.reload();
				},
				onError(e) {
					console.log("form submit error:", e);
				},
				onFinish(e) {
					that.submitButtonDisabled = false;
					console.log("submit FINISH", method, endpoint, "got:", e);
				},
			});
		},
		async deleteContract() {

			let promise = new Promise((resolve, reject) => {
				const response = axios.delete(
					this.$route("external_contract.delete", {
						id: this.contract.id,
					}));

				resolve(response);
				reject(response);
			});

			promise.then(
				(result) => this.onSuccess(result),
				(error) => this.onError(error)
			);
		},
		onSuccess(result) {
			window.parent.location.reload();

			this.$bus.$emit("modal:close");
			this.$bus.$emit("page:content:load");
		},
		onError(error) {
			// todo external contract delete errors abfangen
		},
	},
};
</script>
